import { baseFetch } from '../../baseFetch';
import {
  AllOrgsResponseSchema,
  OrgDetailResponseSchema,
  SearchOrgsResponseSchema,
  UpdateOrgResponseSchema,
  UpdateOrgRequest,
} from './orgs.schema';

export const getAllOrgs = (populate: boolean = false) => {
  return baseFetch(
    'internal',
    '/api/v2/raptor_admin/orgs',
    AllOrgsResponseSchema.defined(),
    {
      searchParams: {
        populate: populate ? '1' : '0',
      },
    },
  );
};

export const getOrgDetails = (orgId: number) =>
  baseFetch('internal-v2', `/orgs/${orgId}/users`, OrgDetailResponseSchema);

export const searchOrgs = (name: string) =>
  baseFetch('internal-v2', '/orgs/search', SearchOrgsResponseSchema, {
    searchParams: { name },
  });

export const updateOrg = (orgId: number, data: UpdateOrgRequest) =>
  baseFetch('internal-v2', `/orgs/${orgId}/name`, UpdateOrgResponseSchema, {
    method: 'PATCH',
    requestBody: data,
  });
